import * as React from 'react';
import { PlannerItemThumbnailInnerContainer } from './PlannerItemThumbnailInnerContainer';

type PlannerItemThumbnailContainerProps = {
    anchorEl: HTMLElement | null;
    open: boolean;
    plannerId: string;
};

export function PlannerItemThumbnailContainer({ anchorEl, open, plannerId }: PlannerItemThumbnailContainerProps) {
    const [shouldLoadThumbnail, setShouldLoadThumbnail] = React.useState(open);

    React.useEffect(() => {
        if (open && !shouldLoadThumbnail) {
            setShouldLoadThumbnail(true);
        }
    }, [open, shouldLoadThumbnail]);

    if (!shouldLoadThumbnail) {
        return <></>;
    }

    return <PlannerItemThumbnailInnerContainer anchorEl={anchorEl} open={open} plannerId={plannerId} />;
}
PlannerItemThumbnailContainer.displayName = 'PlannerItemThumbnailContainer';
